import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FlexLayoutModule } from '@angular/flex-layout';

import { NgScrollbarModule } from 'ngx-scrollbar';

import { CoreThemeCustomizerComponent } from './theme-customizer/theme-customizer.component';
import { CoreDirectivesModule } from '../../directives/directives.module';
import { CoreSidebarsModule } from '../core-sidebars/core-sidebars.module';

@NgModule({
  declarations: [CoreThemeCustomizerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgScrollbarModule,
    CoreDirectivesModule,
    CoreSidebarsModule,
  ],
  exports: [CoreThemeCustomizerComponent],
})
export class CoreThemeCustomizersModule {}
